/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Review_Rating_LabelInputs */

const en_ticket_review_rating_label = /** @type {(inputs: Ticket_Review_Rating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your rating`)
};

const ja_ticket_review_rating_label = /** @type {(inputs: Ticket_Review_Rating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`評価`)
};

const fr_ticket_review_rating_label = /** @type {(inputs: Ticket_Review_Rating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre note`)
};

const de_ticket_review_rating_label = /** @type {(inputs: Ticket_Review_Rating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Bewertung`)
};

/**
* | output |
* | --- |
* | "Your rating" |
*
* @param {Ticket_Review_Rating_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_rating_label = /** @type {((inputs?: Ticket_Review_Rating_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_Rating_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_rating_label(inputs)
	if (locale === "ja") return ja_ticket_review_rating_label(inputs)
	if (locale === "fr") return fr_ticket_review_rating_label(inputs)
	return de_ticket_review_rating_label(inputs)
});